

export default [

	{
		url: "/",
		name: 'Dashboard',
		tagColor: 'warning',
		icon: 'HomeIcon',
		i18n: 'Dashboard',

	},
	{
		url: null,
		name: 'Account',
		tagColor: 'warning',
		icon: 'UserIcon',
		i18n: 'accountManagement',
		submenu: [
			{
				url: '/current-accounts',
				name: 'CurrentAccounts',
				slug: 'CurrentAccounts',
				i18n: 'currentAccounts'
			},
			{
				url: '/current-transactions',
				name: 'CurrentTransactions',
				slug: 'CurrentTransactions',
				i18n: 'currentTransactions'
			},
			{
				url: '/progress-billing',
				name: 'ProgressBilling',
				slug: 'ProgressBilling',
				i18n: 'progressBilling'
			},
			{
				url: '/current-reports',
				name: 'CurrentReports',
				slug: 'CurrentReports',
				i18n: 'reports'
			},
		]
	},
	/*
		{
			url: null,
			name: 'StoreHouse',
			tagColor: 'warning',
			icon: 'ArchiveIcon',
			i18n: 'StoreHouse',
			submenu: [
				{
					url: '/storehouse-list',
					name: 'StoreHouse',
					slug: 'StoreHouse',
					i18n: 'StoreHouse'
				},
	
			]
		},*/
	{
		url: null,
		name: 'Inventory',
		tag: '2',
		tagColor: 'warning',
		icon: 'ListIcon',
		i18n: 'inventoryManagement',
		submenu: [
			{
				url: '/inventory-definitions',
				name: 'InventoryDefinitions',
				slug: 'InventoryDefinitions',
				i18n: 'inventoryDefinitions'
			}, 
			{
				url: '/matched-stock',
				name: 'MatchedStockList',
				slug: 'MatchedStockList',
				i18n: 'matchedStockList'
			},
			{
				url: '/inventory-movements',
				name: 'InventoryMovements',
				slug: 'InventoryMovements',
				i18n: 'inventoryMovements'
			},
			{
				url: '/shelf-operations',
				name: 'ShelfOperations',
				slug: 'ShelfOperations',
				i18n: 'shelfOperations'
			},
			{
				url: '/barcode-printing',
				name: 'BarcodePrinting',
				slug: 'BarcodePrinting',
				i18n: 'barcodePrinting'
			},
			{
				url: '/inventory-counting',
				name: 'InventoryCounting',
				slug: 'InventoryCounting',
				i18n: 'inventoryCounting'
			},
		]
	},
	{
		url: null,
		name: 'Order',
		tag: '2',
		tagColor: 'warning',
		icon: 'ShoppingBagIcon',
		i18n: 'orderManagement',
		submenu: [
			{
				url: '/order-list',
				name: 'OrderList',
				slug: 'OrderList',
				i18n: 'OrderList'
			},
			{
				url: '/order-picking',
				name: 'OrderPicking',
				slug: 'OrderPicking',
				i18n: 'orderPicking'
			},
			{
				url: '/product-packaging',
				name: 'ProductPackaging',
				slug: 'ProductPackaging',
				i18n: 'productPackaging'
			},
			{
				url: '/completed-orders',
				name: 'CompletedOrders',
				slug: 'CompletedOrders',
				i18n: 'completedOrders'
			},
			{
				url: '/order-status',
				name: 'OrderStatus',
				slug: 'OrderStatus',
				i18n: 'OrderStatus'
			},
			{
				url: '/order-reports',
				name: 'OrderReports',
				slug: 'OrderReports',
				i18n: 'reports'
			},

		]
	},
	{
		url: null,
		name: 'ProcurementProcess',
		tagColor: 'warning',
		icon: 'ArchiveIcon',
		i18n: 'procurementProcess',
		submenu: [
			/*		{
						url: '/shipment-work-order',
						name: 'ShipmentWorkOrder',
						slug: 'ShipmentWorkOrder',
						i18n: 'shipmentWorkOrder'
					},*/
			{
				url: '/product-receipt',
				name: 'ProductReceipt',
				slug: 'ProductReceipt',
				i18n: 'productReceipt'
			},

			/*
			{
				url: '/procurement-barcode-printing',
				name: 'ProcurementBarcodePrinting',
				slug: 'ProcurementBarcodePrinting',
				i18n: 'barcodePrinting'
			},*/
		]
	},
	{
		url: null,
		name: 'Definitions',
		tagColor: 'warning',
		icon: 'SearchIcon',
		i18n: 'definitions',
		submenu: [
			{
				url: '/general-definitions',
				name: 'GeneralDefinitions',
				slug: 'GeneralDefinitions',
				i18n: 'generalDefinitions'
			},
			{
				url: '/warehouse-definitions',
				name: 'WarehouseDefinitions',
				slug: 'WarehouseDefinitions',
				i18n: 'warehouseDefinitions'
			},
			{
				url: '/supplier-definitions',
				name: 'SupplierDefinitions',
				slug: 'SupplierDefinitions',
				i18n: 'SupplierDefinitions'
			},
			{
				url: '/shelf-definitions',
				name: 'ShelfDefinitions',
				slug: 'ShelfDefinitions',
				i18n: 'shelfDefinitions'
			},
			{
				url: '/user',
				name: 'UserDefinitions',
				slug: 'UserDefinitions',
				i18n: 'userDefinitions'
			}, {
				url: '/contract-definitions',
				name: 'ContractDefinitions',
				slug: 'ContractDefinitions',
				i18n: 'contractDefinitions'
			},
		]
	},
/*	{
		url: null,
		name: 'Support',
		tagColor: 'warning',
		icon: 'HelpCircleIcon',
		i18n: 'Support',
		submenu: [
			{
				url: '/faq',
				name: 'Faq',
				slug: 'Faq',
				i18n: 'Faq'
			},
		]
	},
	
	{
		url: null,
		name: 'StockTracking',
		tag: '2',
		tagColor: 'warning',
		icon: 'TruckIcon',
		i18n: 'StockTracking',
		submenu: [
			{
				url: '/stock-tracking',
				name: 'StockTrackingList',
				slug: 'StockTrackingList',
				i18n: 'StockTrackingList'
			},
			{
				url: '/stock-tracking-addnew',
				name: 'StockTracking',
				slug: 'StockTracking',
				i18n: 'StockTracking'
			},
		]
	}
*/
]

